module.exports = __webpack_public_path__ + "static/media/jinx-icon.21ad94d3.png";